import React, { useState } from 'react'

import { sort } from '../../utilities/helpers'

import Stack from 'react-bootstrap/Stack'

import SeasonPassSummary from './SeasonPassSummary'
import GameTicketsCompactList from './GameTicketsCompactList'

import './packagePassTicketsView.scss'

function getHolderName(order, accessPass) {
  if (order?.firstName) {
    const lastInitial = order?.lastName ? ` ${order.lastName.charAt(0)}.` : ''
    return `${order.firstName}${lastInitial}`
  }

  if (accessPass?.email) {
    return accessPass.email.split('@')[0]
  }

  return null
}

export default function PackagePassTicketsView({
  accessPasses,
  packageEvents,
  eventPackage,
  orderId,
  order,
}) {
  const [activeView, setActiveView] = useState('pass')

  const ticketCount = sort(packageEvents, 'event')?.reduce(
    (count, packageEvent) => count + (packageEvent?.tickets?.length || 0),
    0
  )
  const eventCount = packageEvents?.length || 0
  const gameTicketsLabelCount = ticketCount || eventCount

  const linkTo = `/event-details/${orderId}`

  return (
    <div className="package-pass-tickets">
      <div
        className="package-pass-tickets__toggle"
        role="tablist"
        aria-label="Package ticket views"
      >
        <button
          type="button"
          role="tab"
          aria-selected={activeView === 'pass'}
          className={`package-pass-tickets__toggle-btn${
            activeView === 'pass'
              ? ' package-pass-tickets__toggle-btn--active'
              : ''
          }`}
          onClick={() => setActiveView('pass')}
        >
          Season pass
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeView === 'events'}
          className={`package-pass-tickets__toggle-btn${
            activeView === 'events'
              ? ' package-pass-tickets__toggle-btn--active'
              : ''
          }`}
          onClick={() => setActiveView('events')}
        >
          Game tickets ({gameTicketsLabelCount})
        </button>
      </div>

      {activeView === 'pass' ? (
        <Stack gap={3}>
          {accessPasses.map((accessPass) => (
            <SeasonPassSummary
              key={accessPass.id || accessPass.uuid}
              accessPass={accessPass}
              eventPackage={eventPackage}
              holderName={getHolderName(order, accessPass)}
              onViewTickets={() => setActiveView('events')}
              showViewTicketsButton={accessPasses.length === 1}
            />
          ))}
        </Stack>
      ) : (
        <GameTicketsCompactList
          packageEvents={packageEvents}
          linkTo={linkTo}
          onBack={() => setActiveView('pass')}
        />
      )}
    </div>
  )
}
